import { Outlet } from 'react-router-dom';

import { Header } from '@/components/layout/Header';

import { Sidebar } from '@/components/layout/Sidebar';

import { SidebarEdgeToggle } from '@/components/layout/SidebarEdgeToggle';

import { masterAdminNav } from '@/config/navigation';

import { BRAND } from '@/config/brand';

import { env } from '@/config/env';

import { useAppDispatch } from '@/hooks/useAppDispatch';

import { useAppSelector } from '@/hooks/useAppSelector';

import { toggleSidebar } from '@/store/appSlice';

import { useWorkspaceTitle } from '@/hooks/useWorkspaceTitle';



export function MasterAdminLayout() {

  const collapsed = useAppSelector((s) => s.app.sidebarCollapsed);

  const dispatch = useAppDispatch();

  useWorkspaceTitle();



  return (

    <div className="workspace-shell flex h-screen flex-col bg-page dark:bg-slate-950">

      <Header moduleLabel="Master Admin" />

      <div className="relative flex min-h-0 flex-1 overflow-hidden">

      {!collapsed && (

        <button

          type="button"

          className="workspace-sidebar-backdrop"

          aria-label="Close sidebar"

          onClick={() => dispatch(toggleSidebar())}

        />

      )}

      <Sidebar

        items={masterAdminNav}

        collapsed={collapsed}

        onToggle={() => dispatch(toggleSidebar())}

        brand={env.appName || BRAND.name}

        appLabel="Master Admin"

      />

      {collapsed && (

        <SidebarEdgeToggle

          collapsed

          onToggle={() => dispatch(toggleSidebar())}

          variant="mobile"

        />

      )}

      <main className="flex-1 overflow-y-auto p-6">

        <Outlet />

      </main>

      </div>

    </div>

  );

}

